import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import type { Logger } from '@core/model/domain/logger';
import { loggerToken } from '@di/angularProviderMapper';
import { ProcessEventService } from '@shared/services/process-event.service';
import { StoreService } from '@shared/services/store.service';
import { VersionCheckService } from '@shared/services/version-check.service';
import { AppVM } from './app.viewmodel';

registerLocaleData(localeFr, 'fr');

@Component({
  selector: 'app-root',
  template: `<router-outlet appDomChange></router-outlet>`,
})
export class AppComponent implements OnInit {
  private appVM: AppVM;

  constructor(
    private processEventService: ProcessEventService,
    private versionCheckService: VersionCheckService,
    private router: Router,
    private storeService: StoreService,
    @Inject(loggerToken) private logger: Logger
  ) {
    this.appVM = new AppVM(this.router, this.storeService, this.processEventService, this.logger);
  }

  ngOnInit(): void {
    this.versionCheckService.initVersionCheck();
    this.appVM.onInit();
  }
}
